import React, { useState, useContext } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { Button, Input, Form, message } from 'antd';
import 'antd/dist/reset.css';
import LoginBackground from '../assets/img/LoginBackground.jpg';
import FormBackground from '../assets/img/FormBackground.jpg';
import authService from '../services/authService';
import { AuthContext } from '../context/AuthContext';

const Login = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const { login } = useContext(AuthContext)!;
    const [loading, setLoading] = useState(false);

    const from = (location.state as any)?.from?.pathname || '/';

    const onFinish = async (values: any) => {
        const { email, password } = values;
        setLoading(true);

        try {
            const response = await authService.login({
                email,
                password,
                role: 'admin',
            });


            const { access_token } = response;

            //Use the login function from context
            login(access_token);

            message.success('Login successful!');
            navigate(from);
        } catch (error: any) {
            if (error.response) {
                const errorMessage = error.response.data.detail || 'Authentication failed';
                message.error(errorMessage);
            } else {
                message.error('Network error. Please try again.');
            }
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="flex h-screen">
            {/* Left Side with Image */}
            <div
                className="hidden md:block w-1/2 bg-cover bg-center opacity-95"
                style={{ backgroundImage: `url(${LoginBackground})` }}
            >
                {/* Optional content or overlay */}
            </div>

            {/* Right Side with Form */}
            <div
                className="relative w-full md:w-1/2 flex items-center justify-center bg-cover bg-center"
                style={{ backgroundImage: `url(${FormBackground})` }}
            >
                {/* Optional Overlay */}
                <div className="absolute inset-0 bg-white opacity-95"></div>

                {/* Form Content */}
                <div className="relative max-w-md w-full space-y-8 p-10">
                    {/* Welcome Text */}
                    <h1 className="text-2xl font-bold text-center text-black">
                        VOTING ANALYSIS DASHBOARD
                    </h1>

                    <Form
                        name="login"
                        layout="vertical"
                        initialValues={{ remember: true }}
                        onFinish={onFinish}
                    >
                        {/* Email Field */}
                        <Form.Item
                            name="email"
                            rules={[
                                { required: true, message: 'Please input your Email!' },
                                { type: 'email', message: 'Please enter a valid email!' },
                            ]}
                            label="Email"
                        >
                            <Input placeholder="Enter your email" size="large" />
                        </Form.Item>

                        {/* Password Field */}
                        <Form.Item
                            name="password"
                            rules={[{ required: true, message: 'Please input your Password!' }]}
                            label="Password"
                        >
                            <Input.Password placeholder="Enter your password" size="large" />
                        </Form.Item>

                        {/* Submit Button */}
                        <Form.Item>
                            <Button
                                type="primary"
                                htmlType="submit"
                                className="w-full"
                                size="large"
                                loading={loading} // Add loading prop
                            >
                                {loading ? 'Logging in...' : 'Log in'}
                            </Button>
                        </Form.Item>
                    </Form>
                </div>
            </div>
        </div>
    );
};

export default Login;